import React from "react";
import styled from "styled-components/macro";

const StyledRoot = styled.div`
  margin: 1rem 0;
  color: var(--dark-gray);

  h3 {
    color: var(--dark-gray);
  }

  h3 {
    margin-top: 0;
  }

  .box {
    display: grid;
    padding: 1rem;
    padding-top: 2rem;
    padding-bottom: 2rem;
    background-color: var(--white);
    border-radius: var(--rounded-corner-large);
    border: 1px solid var(--border-gray-light);
    box-shadow: var(--drop-shadow);
    margin: 0.5rem 0;
    grid-template-columns: 1fr 4fr 12rem;
    align-items: flex-start;
    justify-items: center;

    li {
      color: var(--primary-black);
      font-size: 14px;
      margin: 0.25rem 0;
    }

    .buttons {
      display: flex;
      align-content: center;
      flex-flow: column;
      gap: 1rem;
      text-align: center;
      width: 100%;
      align-self: flex-start;

      button {
        width: 100%;
      }
    }
    .description {
      width: 100%;
      padding: 0 1rem;
    }
  }
`;

interface IntegrationSectionProps {
  title: string;
  logo: React.ReactNode;
  isConnected: boolean;
  descriptionComponent: React.ReactNode;
  actionComponents: React.ReactNode;
}

export const IntegrationSection: React.FC<IntegrationSectionProps> = ({
  title,
  actionComponents,
  descriptionComponent,
  logo,
  isConnected,
}) => {
  return (
    <StyledRoot>
      <h3>{title}</h3>
      <div className="box">
        {logo}
        <div className="description">
          <h3>{isConnected ? "Connected" : "Not connected"}</h3>
          {descriptionComponent}
        </div>
        <div className="buttons">{actionComponents}</div>
      </div>
    </StyledRoot>
  );
};
